import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Signup.css';
import iconBack from '../../assets/images/icon-back.svg';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../contexts/AuthContext';

interface LocationState {
  snsType?: string;
  snsId?: string;
  email?: string;
  name?: string;
  phone?: string;
  carrier?: string;
  gender?: string;
  age?: string;
  location?: string;
}

const Nickname: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  const { login } = useAuth();
  const [nickname, setNickname] = useState('해피해피 민들레');
  const [isLoading, setIsLoading] = useState(false);

  const generateRandomNickname = () => {
    const adjectives = ['행복한', '즐거운', '신나는', '귀여운', '멋진', '예쁜'];
    const nouns = ['민들레', '해바라기', '장미', '튤립', '국화', '백합'];
    const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    setNickname(`${adj} ${noun}`);
  };

  const handleComplete = async () => {
    if (!nickname) {
      alert('닉네임을 입력해주세요.');
      return;
    }

    setIsLoading(true);

    try {
      // 이미 가입된 사용자인지 확인 (SNS ID)
      const { data: existingCustomer } = await supabase
        .from('customers')
        .select('*')
        .eq('sns_id', state?.snsId)
        .single();

      if (existingCustomer) {
        alert('이미 가입된 회원입니다. 로그인합니다.');
        await login(state?.snsId!);
        navigate('/main');
        return;
      }

      // 전화번호 중복 확인 (전화번호가 있을 때만)
      if (state?.phone) {
        const { data: existingPhone } = await supabase
          .from('customers')
          .select('*')
          .eq('phone', state.phone)
          .single();

        if (existingPhone) {
          alert('이미 가입된 전화번호입니다.\n다른 계정으로 가입하셨다면 해당 계정으로 로그인해주세요.');
          setIsLoading(false);
          navigate('/login');
          return;
        }
      }

      // 현재 Supabase 세션에서 auth_user_id 가져오기
      const { data: { session } } = await supabase.auth.getSession();
      const authUserId = session?.user?.id;

      // 새로운 고객 프로필 생성
      const { error } = await supabase
        .from('customers')
        .insert([
          {
            sns_type: state?.snsType,
            sns_id: state?.snsId,
            email: state?.email,
            name: state?.name,
            phone: state?.phone,
            carrier: state?.carrier,
            gender: state?.gender,
            age_group: state?.age,
            address: state?.location,
            nickname: nickname,
            is_active: true,
            auth_user_id: authUserId  // 구글 OAuth용 auth_user_id 저장
          }
        ]);

      if (error) {
        console.error('회원가입 오류:', error);

        // 전화번호 중복 에러 처리
        if (error.code === '23505' && error.message?.includes('phone')) {
          alert('이미 가입된 전화번호입니다.\n다른 계정으로 가입하셨다면 해당 계정으로 로그인해주세요.');
          navigate('/login');
        } else {
          alert('회원가입 중 오류가 발생했습니다.');
        }
        setIsLoading(false);
        return;
      }

      // 회원가입 성공 후 로그인 처리
      await login(state?.snsId!);
      alert('회원가입이 완료되었습니다!');
      navigate('/main');
    } catch (error) {
      console.error('회원가입 오류:', error);
      alert('회원가입 중 오류가 발생했습니다.');
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="signup-container">
      <div className="signup-header">
        <button className="back-button" onClick={handleBack}>
          <img src={iconBack} alt="뒤로가기" />
        </button>
      </div>

      <div className="signup-content">
        <div className="signup-inner">
          <div className="signup-form">
            <div className="signup-title-section">
              <h1 className="signup-title">
                마음에 드는 닉네임을
                <br />
                설정해 주세요.
              </h1>
            </div>

            <div className="nickname-section">
              <input
                type="text"
                className="signup-input nickname-input"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                maxLength={20}
              />
              <button className="change-nickname-btn" onClick={generateRandomNickname}>
                다른 닉네임
              </button>
            </div>
          </div>

          <div className="signup-footer-complete">
            <button
              className={`signup-btn complete ${nickname ? 'active' : ''}`}
              onClick={handleComplete}
              disabled={!nickname || isLoading}
            >
              {isLoading ? '가입 중...' : '완료'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nickname;
